export default{
  label:'shadow',
  valueScope:[
    'shadow-none',
    'shadow-sm',
    'shadow',
    'shadow-lg',
  ]
}



// WEBPACK FOOTER //
// ./src/shell/schemas/general/shadow.js